<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="card h-100 mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t("content.amnreportdefer") }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-lg-4  mt-0">
                <fieldset>
                  <div class="item">
                    <material-checkbox v-model="time" :checked="time" name="autoSelect" @change="onserachDate">
                      <label class="form-label m-0">{{ $t("content.sdate") }}</label>
                    </material-checkbox>
                    <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                      :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true" month-name-format="long"
                      :clearable="false" fluid :disabled="!time && !complete_search" :text-input="textInputOptions" />
                  </div>
                </fieldset>
              </div>

              <div class="col-lg-4 mt-2">
                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                  :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true" month-name-format="long"
                  :clearable="false" fluid :disabled="!time && !complete_search" :text-input="textInputOptions" />
              </div>

              <div class="col-lg-4 mt-2">
                <label class="form-label ms-0">{{ $t("content.names") }}</label>
                <div class="input-group">
                  <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                    readonly />
                  <button class="btn btn-primary" type="button" @click="openDialogCus">
                    <i class="material-icons material-symbols-outlined">search</i>
                  </button>
                  <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                    data-bs-target="#searchNameModal" v-show="false">
                  </button>
                </div>
              </div>

              <div class="col-lg-4 mt-3">
                <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                <material-input type="text" v-model="tk_search" />
              </div>

              <div class="col-lg-4 mt-3">
                <label class="form-label ms-0">{{ $t("content.defermeth") }}</label>
                <select class="form-select" v-model="type_search">
                  <option value="" selected>{{ $t("content.optall") }}</option>
                  <option value="CUSTOMER">{{ $t("content.cuspostpone") }}</option>
                  <option value="USER">{{ $t("content.userpostpone") }}</option>
                </select>
              </div>

              <div class="col-lg-4  mt-1">
                <fieldset>
                  <div class="item">
                    <span class="form-label m-0">{{ $t("content.rptdayod") }}</span>
                    <div class="d-inline-block mx-2">
                      <material-checkbox id="activewc" v-model="active_search" :checked="active_search"  @change="complete_search = false;time = false;onserachDate()"
                        name="autoSelect">{{ $t("content.activewc") }}
                      </material-checkbox>
                    </div>
                    <div class="d-inline-block mx-2">
                      <material-checkbox id="completewc" v-model="complete_search" :checked="complete_search" @change="active_search = false;onserachDate()"
                        name="autoComplete">{{ $t("content.postponecomp") }}
                      </material-checkbox>
                    </div>

                    <select class="form-select" v-model="duration_search">
                      <option value="" selected>{{ $t("content.optall") }}</option>
                      <option value="15">{{ $t("content.duration15") }}</option>
                      <option value="30">{{ $t("content.duration30") }}</option>
                      <option value="45">{{ $t("content.duration45") }}</option>
                      <option value="60">{{ $t("content.duration60") }}</option>
                      <option value="90">{{ $t("content.duration90") }}</option>
                      <option value="more90">{{ $t("content.durationmore90") }}</option>
                    </select>
                  </div>
                </fieldset>
              </div>

            </div>

            <div class="row mt-4">
              <div class="col-3 d-flex justify-content-between align-items-center"></div>
              <div class="col-9 d-flex justify-content-end align-items-center">
                <div class="me-3">
                  <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                    @click="loadDataReportApi">
                    <i class="material-icons material-symbols-outlined">search</i>
                    {{ search }}
                  </material-button>
                </div>
                <div class="me-3">
                  <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                    @click="cancelBtn">
                    <i class="material-icons material-symbols-outlined">close</i>
                    {{ cancel }}
                  </material-button>
                </div>
              </div>
            </div>

            <hr />
            <div class="d-flex justify-content-end align-items-center">
              <label class="form-label m-0 me-2">{{ $t("content.expfile") }} :</label>
              <material-button id="pdfBtn" color="info" variant="outline" class="float-lg-start float-sm-end mb-0 me-2"
                @click="pdfGen" :disabled="listrpt.length === 0">
                <i class="material-icons material-symbols-outlined">picture_as_pdf</i> pdf
              </material-button>
              <material-button id="labelBtn" color="info" variant="outline"
                cclass="float-lg-start float-sm-end mb-0 me-2" @click="labelGen" :disabled="listrpt.length === 0">
                <i class="material-icons material-symbols-outlined">description</i> {{ $t("content.lbasset") }}
              </material-button>
            </div>
            <div class="row mt-3">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>{{ $t("content.ticketno") }}</th>
                      <th>{{ $t("content.stockno") }}</th>
                      <th>{{ $t("content.names") }}</th>
                      <th>{{ $t("content.amnlocationasset") }}</th>
                      <th>{{ $t("content.lasttrf") }}</th>
                      <th>{{ $t("content.compdate") }}</th>
                      <th>{{ $t("content.amndeferdate") }}</th>
                      <th>{{ $t("content.amnduedate") }}</th>
                      <th>{{ $t("content.amnduedatenew") }}</th>
                      <th>{{ $t("content.defermeth") }}</th>
                      <th class="text-center">{{ $t("content.amnduedateadd") }}</th>
                      <th>{{ $t("content.amnpawnvalall") }}</th>
                      <th class="text-center">{{ $t("content.detail") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in listrpt" :key="index" :class="{ 'bg-danger-light': isPastToday(row.postponeDate) }">
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.refNumber }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.stockNumber }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.cusName }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.locName }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ format_datetime(row.txDate) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ format_datetime(row.completeDate) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ format_datetime(row.createDate) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ format_date(row.dueDate) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ format_date(row.postponeDate) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        <span v-if="row.type === 'USER'">
                          {{ $t("content.userpostpone") }}
                        </span>
                        <span v-else-if="row.type === 'CUSTOMER'">
                          {{ $t("content.cuspostpone") }}
                        </span>
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        {{ formatNumberString(row.days) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.pawnValue) }}
                      </td>
                      <td class="text-sm font-weight-normal text-center">
                        <material-button color="info" variant="outline" class="rounded-circle"
                          :title="t('buttons.seed')" @click="openDetail(row)">
                          <i class="material-icons material-symbols-outlined">visibility</i>
                        </material-button>
                        <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                          data-bs-toggle="modal" data-bs-target="#lookupModal2" id="detailModal">
                        </material-button>
                        <material-button color="warning" variant="outline" class="rounded-circle"
                          @click="getHistory(row)" :title="t('content.historyview')">
                          <i class="material-icons material-symbols-outlined">navigate_next</i>
                        </material-button>
                      </td>
                    </tr>
                    <tr v-if="listrpt.length === 0">
                      <td colspan="18" class="text-sm font-weight-normal">
                        <p style="text-align: center">No Record Found</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="group-sub-header">
                      <td class="text-lg font-weight-bold text-end text-center" colspan="12">
                        <span v-if="listrpt.length > 0">
                          <b>{{ $t("content.gtotal") }}</b>
                        </span>
                      </td>

                      <td class="text-lg font-weight-bold">
                        <span v-if="listrpt.length > 0">
                          <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                        </span>
                      </td>
                      <td style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <pre></pre>
            <div style="display: flex; justify-content: flex-end">
              <ul v-show="listrpt.length > 0" class="pagination justify-content-end">
                <div class="project-container">
                  <div class="example-one">
                    <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                      @click="onClickHandler" />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>

        <!-- Search Customer Dialog -->
        <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div class="preview-table">
                  <section class="panel">
                    <table class="table table-striped table-responsive">
                      <thead>
                        <tr>

                          <th>#</th>
                          <th>{{ $t("content.cnameth") }}</th>
                          <th>{{ $t("content.cnameen") }}</th>
                          <th>{{ $t("content.docno") }}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="row-search">
                          <td></td>
                          <td>
                            <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                          </td>
                          <td>
                            <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                          </td>
                          <td>
                            <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                          </td>
                          <td>
                            <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                              :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                              @click="loadCustomerAfListApi">
                              <i class="material-icons material-symbols-outlined">search</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-for="(row, index) in customerlist" :key="index" @click="selectCus(row)">
                          <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                          <td>{{ row.nameTh }}</td>
                          <td>{{ row.nameEn }}</td>
                          <td colspan="2">{{ row.docNumber }}</td>
                        </tr>
                        <tr v-if="customerlist.length === 0">
                          <td colspan="5" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>

              <div class="modal-footer">
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                          :items-per-page="perPageC" @click="onClickHandlerC" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


          <!-- Detail Modal -->
          <TicketDetailModal 
          v-if="workcaseDetail !== null"
          :workcaseDetail="workcaseDetail"
          :images="images"
          :listinfo="listinfo"
          :paymentE="paymentE"
          :paymentL="payment_l"
          :promotionDetail="promotionDetail"
          :depRef="dep_ref"
          :tkStatus="tk_status"
          :intCal="int_cal"
          :intPeriod="int_period"
          :transactionLabel="checkTransaction(workcaseDetail.transactionType)"
          :history="'no'" 
          v-model:fcusdt="fcusdt" 
          :afChangename=af_changename
          :bfChangename=bf_changename
          :transDatePrv=transdate_prv
          @copy="copyBtn"
          @openHistory="NewTab"/>



      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref, nextTick } from "vue";
import { useI18n } from "vue-i18n";

import ProgressSpinner from 'primevue/progressspinner';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue"
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import TicketDetailModal from '@/components/TicketDetailModal.vue';

import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"

import { useCashAccountStore } from '@/stores/cashaccount'
import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useInterestStore } from '@/stores/interest'
import { useShopStore } from '@/stores/shop'
import { usePostponeStore } from '@/stores/postpone'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDepositStore } from '@/stores/deposit'


const storeca = useCashAccountStore()
const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const storei = useInterestStore()
const storesh = useShopStore()
const storep = usePostponeStore()
const storepay = usePaymentGroupStore()
const storedepo = useDepositStore()

const { t } = useI18n();
const swal = inject("$swal");

const images = ref([])
const images_l = ref([])
const shop_detail = ref({})
const shop_info = ref(null)
const payment_l = ref([])
const loading = ref(false);
const listrpt = ref([]);
const listinfo = ref([]);
const customerlist = ref([])
const info_cat = ref('');
const workcaseDetail = ref(null);
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const time = ref(false);
const int_period = ref('');
const totalPawnValue = ref(0);
const dep_ref = ref('');
const bf_changename = ref('');
const af_changename = ref('');

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')

const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const cusUid_search = ref('');
const cusName_search = ref('');
const tk_search = ref('');
const type_search = ref('');
const duration_search = ref('');
const active_search = ref(false);
const complete_search = ref(false);
const promotionDetail = ref(null);
const fcusdt = ref(false)
const transdate_prv = ref(null);

const search = computed(() => t("buttons.sear"));
const cancel = computed(() => t("buttons.canc"));

const onClickHandler = (page) => {
  updatePagination()
};

const onClickHandlerC = (page) => {
  updatePaginationC()
};


const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}

function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

const textInputOptions = {
  format: 'dd/MM/yyyy HH:mm'
};

const getshopInfo = async (val) => {
  shop_detail.value = {}
  const response = await storeca.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_detail.value = response.data.data
        if (sessionStorage.getItem('deferReport') !== null) { 
          sessionStorage.removeItem('deferReport');
          active_search.value = true
        }
        loadDataReportApi()
      }
    }
  }
}

getshopInfo()

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}

const onserachDate = () => {
  if (!time.value && !complete_search.value) {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
  }
};

const isPastToday = (dateString) => {
  if (!dateString) return false;
  
  const today = new Date();
  today.setHours(0, 0, 0, 0); // รีเซ็ตเวลาเพื่อเทียบเฉพาะ "วันที่"
  
  const targetDate = new Date(dateString);
  return targetDate < today; // คืนค่า true ถ้าวันที่ในแถว "เก่ากว่า" วันนี้
};


function cancelBtn() {
  time.value = false;
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
  cusUid_search.value = '';
  cusName_search.value = '';
  tk_search.value = '';
  duration_search.value = '';
  currentPage.value = 1
  listrpt.value = []
  totalRows_s.value = ''
  type_search.value = ''
  totalPawnValue.value = 0
  active_search.value = false
  complete_search.value = false
  loadDataReportApi()
}


async function loadDataReportApi() {
  let data = "";
  let sd = ''
  let ed = ''
  let dayStart = 0
  let dayEnd = 0
  totalPawnValue.value = 0

  if (time.value || complete_search.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')

  }

  if (duration_search.value !== '') {
    if (duration_search.value === '15') {
      dayStart = 1
      dayEnd = 15
    } else if (duration_search.value === '30') {
      dayStart = 16
      dayEnd = 30
    } else if (duration_search.value === '45') {
      dayStart = 30
      dayEnd = 45
    } else if (duration_search.value === '60') {
      dayStart = 45
      dayEnd = 60
    } else if (duration_search.value === '90') {
      dayStart = 60
      dayEnd = 90
    } else if (duration_search.value === 'more90') {
      dayStart = 90
      dayEnd = -1
    }
  }

  if (cusUid_search.value !== '' || tk_search.value || type_search.value !== '' || duration_search.value !== '' || active_search.value || complete_search.value) {
    currentPage.value = 1
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value.trim(),
    fromDate: sd,
    toDate: ed,
    type: type_search.value,
    dayStart: dayStart,
    dayEnd: dayEnd,
    active: active_search.value,
    completeInDateRange: complete_search.value
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storep.postPoneListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrpt.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalPawnValue.value = response.data.data.ext.pawnValue
      }
    }
  }
}


async function updatePagination() {
  listrpt.value = []
  totalPawnValue.value = 0
  let data = "";
  let sd = ''
  let ed = ''
  let dayStart = 0
  let dayEnd = 0


  if (time.value || complete_search.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')

  }

  if (duration_search.value !== '') {
    if (duration_search.value === '15') {
      dayStart = 1
      dayEnd = 15
    } else if (duration_search.value === '30') {
      dayStart = 16
      dayEnd = 30
    } else if (duration_search.value === '45') {
      dayStart = 30
      dayEnd = 45
    } else if (duration_search.value === '60') {
      dayStart = 45
      dayEnd = 60
    } else if (duration_search.value === '90') {
      dayStart = 60
      dayEnd = 90
    } else if (duration_search.value === 'more90') {
      dayStart = 90
      dayEnd = -1
    }
  }



  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: cusUid_search.value,
    refNumber: tk_search.value.trim(),
    fromDate: sd,
    toDate: ed,
    type: type_search.value,
    dayStart: dayStart,
    dayEnd: dayEnd,
    active: active_search.value,
    completeInDateRange: complete_search.value
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storep.postPoneListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listrpt.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        totalPawnValue.value = response.data.data.ext.pawnValue
      }
    }
  }
}


async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}


async function selectCus(item) {
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}


async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,    
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,    
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid

  };
  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCashAccDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  await getworkCaseInfo(item.refNumber)
  if (workcaseDetail.value != null) {

    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }

    if (workcaseDetail.value.deposit) {
      getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
        calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
      getTicketImage()
      await nextTick();
      document.getElementById("detailModal").click();
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();

    }
  }
}


async function getTicketImage() {

  if (images.value.length === 0) {
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      // console.log("logoUid : " + item.images[i].imageUid);
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }

    if (url.length > 0) {
      await getFile(url)
      if (images.value.length > 0) {
        // await nextTick();
        // document.getElementById("detailModal").click();
      } else {
        let obj = {
          src: noImg,
          thumbnailImageSrc: noImg,
          alt: '',
          title: ''
        }
        images.value.push(obj)
        // await nextTick();
        // document.getElementById("detailModal").click();
      }
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      // await nextTick();
      // document.getElementById("detailModal").click();
    }

  } else {
    // await nextTick();
    // document.getElementById("detailModal").click();
  }
}

async function getFile(urls) {
  let file_L = []
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
  const requests = urls.map((url) => axios.get(url));
  await Promise.all(requests).then(allResults => {
    if (allResults) {
      file_L = allResults
      if (file_L !== null) {

        for (let i = 0; i < file_L.length; i++) {
          // console.log('file_L : ' + JSON.stringify(file_L.value[i].data.data.data) + ' file_L 2 : ' + JSON.stringify(file_L.value[i].data.data.name));
          if (file_L[i].data.data !== null) {
            const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
            const data = URL.createObjectURL(file);
            let obj = {
              src: data,
              thumbnailImageSrc: data,
              alt: '',
              title: ''
            }
            images.value.push(obj)
          }

          // console.log('File xx : ', file_L.value[i].file.type + 'File size : ', file_L.value[i].file.size + ' bytes in size  name : ' + file_L.value[i].data.data.name);
        }
      }
    }
  })

}

function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  // const trimmedString = string64;
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function getworkCaseInfo(refNumber) {
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: refNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}

async function calIntInt() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }
  let cusUid = workcaseDetail.value.customerInfo.customerUid
  
  if(workcaseDetail.value.represent || workcaseDetail.value.shopRepresent){
      cusUid =  workcaseDetail.value.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid: cusUid,
    txType: workcaseDetail.value.transactionType,
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod
      }
    }
  }
}



async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    uid: item,
  };
  const payload = data;
  // const response = await store.dispatch("unitUpdateFetch", payload);

  const response = await storepay.paymentGroupinfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}


function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  }
  return side
}


function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}


async function getShopInfo() {
  shop_info.value = null
  let data = "";
  data = {
    uid: shop_detail.value.uid,
  };
  const payload = data;
  const response = await storesh.shopInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_info.value = response.data.data
        // console.log('shop_info : ' + JSON.stringify(shop_info.value));
      }
    }
  }
}



async function pdfGen() {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  let sd = ''
  let ed = ''
  let dayStart = 0
  let dayEnd = 0


  if (time.value || complete_search.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  }

  if (duration_search.value !== '') {
    if (duration_search.value === '15') {
      dayStart = 1
      dayEnd = 15
    } else if (duration_search.value === '30') {
      dayStart = 16
      dayEnd = 30
    } else if (duration_search.value === '45') {
      dayStart = 30
      dayEnd = 45
    } else if (duration_search.value === '60') {
      dayStart = 45
      dayEnd = 60
    } else if (duration_search.value === '90') {
      dayStart = 60
      dayEnd = 90
    } else if (duration_search.value === 'more90') {
      dayStart = 90
      dayEnd = -1
    }
  }
  data = {
    page: {
      index: "0",
      size: "0", // size=0 all result
      sort: ""
    },
    filter: {
      groupUid: shop_info.value.groupUid,
      shopUid: shop_info.value.uid,
      fromDate: sd,
      toDate: ed,
      customerUid: cusUid_search.value,
      tkRefNumber: tk_search.value.trim(),
      shopName: shop_info.value.fullname,
      cusUid: cusUid_search.value,
      refNumber: tk_search.value.trim(),
      type: type_search.value,
      dayStart: dayStart,
      dayEnd: dayEnd,
      active: active_search.value,
      completeToday: false,
      completeInDateRange: complete_search.value
    },
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/postpone/list/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}


async function labelGen() {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  let sd = ''
  let ed = ''
  let dayStart = 0
  let dayEnd = 0



  if (time.value || complete_search.value) {
    sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
    ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')

  }

  if (duration_search.value !== '') {
    if (duration_search.value === '15') {
      dayStart = 1
      dayEnd = 15
    } else if (duration_search.value === '30') {
      dayStart = 16
      dayEnd = 30
    } else if (duration_search.value === '45') {
      dayStart = 30
      dayEnd = 45
    } else if (duration_search.value === '60') {
      dayStart = 45
      dayEnd = 60
    } else if (duration_search.value === '90') {
      dayStart = 60
      dayEnd = 90
    } else if (duration_search.value === 'more90') {
      dayStart = 90
      dayEnd = -1
    }
  }
  data = {
    page: {
      index: "0",
      size: "0", // size=0 all result
      sort: ""
    },
    filter: {
      groupUid: shop_info.value.groupUid,
      shopUid: shop_info.value.uid,
      fromDate: sd,
      toDate: ed,
      customerUid: cusUid_search.value,
      tkRefNumber: tk_search.value.trim(),
      shopName: shop_info.value.fullname,
      cusUid: cusUid_search.value,
      refNumber: tk_search.value.trim(),
      type: type_search.value,
      dayStart: dayStart,
      dayEnd: dayEnd,
      active: active_search.value,
      completeToday: false,
      completeInDateRange: complete_search.value
    },
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/postpone/list/label`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
      }
    }
  }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name
        transdate_prv.value = workcase_prv.workItems[0].startTime 
      }
    }
  }
}

async function getHistory(item) {
  workcaseDetail.value = null
  await getworkCaseInfo(item.refNumber)
  if (workcaseDetail.value != null) {
    sessionStorage.removeItem('deferWorkcaseUid');
    sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
    if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
      const win = window.open("#/generals/defer_items", "_blank");
      win.focus();
      sessionStorage.removeItem('deferWorkcaseUid');
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-danger-light {
  background-color: #ffe5e5 !important; /* สีแดงอ่อน */
}
</style>
